export const DEFAULT_WEB_THEME = {
  primaryColor: '#780202',
  topbarColor: '#780202',
  topbarTextColor: '#FFCA08',
  sidebarBgColor: '#FFFFFF',
  sidebarTextColor: '#1F2937',
  sidebarActiveColor: '#FFF3BF',
  pageBgColor: '#F6F7FB',
  cardBgColor: '#FFFFFF',
  buttonColor: '#780202',
  buttonTextColor: '#FFFFFF',
  fontFamily: 'Roboto',
  borderRadius: 4,
};

export const normalizeWebTheme = (data = {}) => ({
  primaryColor: data.primaryColor || DEFAULT_WEB_THEME.primaryColor,
  topbarColor: data.topbarColor || DEFAULT_WEB_THEME.topbarColor,
  topbarTextColor: data.topbarTextColor || DEFAULT_WEB_THEME.topbarTextColor,
  sidebarBgColor: data.sidebarBgColor || DEFAULT_WEB_THEME.sidebarBgColor,
  sidebarTextColor: data.sidebarTextColor || DEFAULT_WEB_THEME.sidebarTextColor,
  sidebarActiveColor: data.sidebarActiveColor || DEFAULT_WEB_THEME.sidebarActiveColor,
  pageBgColor: data.pageBgColor || DEFAULT_WEB_THEME.pageBgColor,
  cardBgColor: data.cardBgColor || DEFAULT_WEB_THEME.cardBgColor,
  buttonColor: data.buttonColor || DEFAULT_WEB_THEME.buttonColor,
  buttonTextColor: data.buttonTextColor || DEFAULT_WEB_THEME.buttonTextColor,
  fontFamily: data.fontFamily || DEFAULT_WEB_THEME.fontFamily,
  borderRadius: Number(data.borderRadius) || DEFAULT_WEB_THEME.borderRadius,
});

export const applyWebThemeVariables = (theme) => {
  const root = document.documentElement;
  const values = normalizeWebTheme(theme);

  root.style.setProperty('--web-theme-primary', values.primaryColor);
  root.style.setProperty('--web-theme-topbar', values.topbarColor);
  root.style.setProperty('--web-theme-topbar-text', values.topbarTextColor);
  root.style.setProperty('--web-theme-sidebar-bg', values.sidebarBgColor);
  root.style.setProperty('--web-theme-sidebar-text', values.sidebarTextColor);
  root.style.setProperty('--web-theme-sidebar-active', values.sidebarActiveColor);
  root.style.setProperty('--web-theme-page-bg', values.pageBgColor);
  root.style.setProperty('--web-theme-card-bg', values.cardBgColor);
  root.style.setProperty('--web-theme-button', values.buttonColor);
  root.style.setProperty('--web-theme-button-text', values.buttonTextColor);
  root.style.setProperty('--web-theme-font-family', values.fontFamily);
  root.style.setProperty('--web-theme-radius', `${values.borderRadius}px`);
};
